export default "__VITE_PUBLIC_ASSET__24947711__"